@use '../../style/mixins';

:host(limel-help-content) {
    display: flex;
    box-sizing: border-box;
    flex-direction: column;
    gap: 0.5rem;

    max-height: 30rem;
    height: 100%;
}

limel-markdown {
    @include mixins.fade-out-overflowed-content-on-edges(vertically);

    padding-right: 1rem;
    padding-left: 1rem;
    min-height: 0;
    min-width: 0;
    overflow: hidden auto;
}

a {
    @include mixins.truncate-text;
    @include mixins.hyperlink;

    position: sticky;
    bottom: 0;

    text-decoration: none;
    font-size: var(--limel-theme-default-font-size);
    padding-bottom: 0.125rem;
}

span {
    padding: 0 1rem 0.5rem 1rem;
    min-width: 0;
}
